import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import _find from 'lodash/find';

import queries from '../../utils/queries.js'

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.porcImpto} dato2={props.elemento.descrImpto} value={props.elemento.codigoImpto}>{props.elemento.descrImpto} ={">"} {props.elemento.porcImpto}%</option>
  )
};

const Lista = ({handleLista, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="impto" id="miLista" onChange={handleLista}>
        <option value="">No tiene impuesto</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleNivel1Cl = props => {
  return (
    <option dato1={props.elemento.codigoClaseServ} value={props.elemento._id} style={props.styles.input}>{props.elemento.descrClaseServ}</option>
  )
};

const ListaCl = ({styles, handleLista1, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1Cl styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="clase" id="miLista1" onChange={handleLista1}>
        <option style={styles.input} value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const AddOtpa2 = ({styles, list, handleLista, handleLista1, handleSubmit, handleChange, args,
                    errors, data: {allClasesServ=[], props}}) => {
// console.log(this.props,args)
  return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Concepto de otros pagos del cliente nuevo
      </button>
      <div style={styles.box}>
        <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={styles.label}>Concepto</label>
                  <Form.Input autoComplete="off" name="descrOtrosPagCl" id="descrOtrosPagCl" onChange={handleChange} placeholder='Concepto' icon={!errors.length?null: _find(errors, {path:'descrUndMat'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Impuesto</label>
                  <Lista list={list} styles={styles} handleLista={handleLista} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Clase</label>
                  <ListaCl styles={styles} list={allClasesServ} handleLista1={handleLista1} />
                </Form.Field>

                <Button type='submit' primary fluid>
                  Agregar
                </Button>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default graphql(queries.query.allClasesServ)(AddOtpa2)
